import React, { memo } from "react";
import { Button, useMutation, useNotify, useRedirect } from "react-admin";
import { useFormState } from "react-final-form";
import SaveIcon from "@material-ui/icons/Save";

interface ISaveButtonStudentSubsidy {
  formInvalid: boolean;
}

const SaveButtonStudentSubsidy = ({
  formInvalid,
}: ISaveButtonStudentSubsidy) => {
  const notify = useNotify();
  const redirect = useRedirect();
  const { values } = useFormState();

  const [saveStudentSubsidy, { loading }] = useMutation(
    {
      type: "create",
      resource: "studentSubsidies",
      payload: {
        data: {
          periodStartDate: values.periodStartDate,
          periodEndDate: values.periodEndDate,
          subsidyPercentage: values.subsidyPercentage,
          studentIdentifier: values.studentId,
          remark: values.remark,
          // Set value for studentIdentifierType field.
          // This will be used for StudentIdentifierType in the API.
          // Means, It will get the student data by StudentId.
          studentIdentifierType: "studentId",
        },
      },
    },
    {
      onSuccess: ({ res }) => {
        notify("Success Update Student Subsidy", "info");
        redirect(`/students/${res.json.studentId}/show/6`);
        window.location.reload();
      },
      onFailure: (error) => {
        notify(
          `Failed Update Student Subsidy, error: ${error.message}`,
          "error",
        );
      },
    },
  );

  return (
    <Button
      label={loading ? `Loading...` : `Save`}
      disabled={formInvalid || loading}
      onClick={saveStudentSubsidy}
    >
      <SaveIcon />
    </Button>
  );
};

export default memo(SaveButtonStudentSubsidy);
